import * as THREE from "three";
import Universe from "./universe";


document.addEventListener("DOMContentLoaded", () => {
    const root = document.getElementById('root')

    const universe = new Universe();

//     // root.appendChild()

// //    let cube = new Cube(root)
// //    window.cube = cube;

    // root.appendChild(starfield);
    // root.appendChild(universe);


})